<template>
  <div id="app-nav">
    <ul class="sidebar-menu">
      <li class="header">MAIN NAVIGATION</li>
      <li class="active treeview">
        <a href="#">
          <i class="fa fa-dashboard"></i> <span>Dashboard</span>
          <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/"><i class="fa fa-circle-o"></i> Summary</router-link></li>
          <li><router-link to="/engagement"><i class="fa fa-circle-o"></i> Engagement</router-link></li>
        </ul>
      </li>
      <li>
        <router-link to="/channels">
          <i class="fa fa-tasks"></i> <span>Channels</span>
        </router-link>
      </li>
      <!--<li>
        <router-link to="/facilities">
          <i class="fa fa-hospital-o"></i> <span>Facilities</span>
        </router-link>
      </li>
      <li class="treeview">
        <a href="#">
          <i class="fa fa-dashboard"></i> <span>Cost & Acquisition</span>
          <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/channel"><i class="fa fa-circle-o"></i> Create Channel</router-link></li>
          <li><router-link to="/report"><i class="fa fa-circle-o"></i> Log Report</router-link></li>
          <li><router-link to="/view-statistics"><i class="fa fa-circle-o"></i> View Report</router-link></li>
        </ul>
      </li> -->
      <li class="active treeview">
        <a href="#">
          <i class="fa fa-envelope-o"></i> <span>Generic SMS Apps</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li><router-link to="/apps"><i class="fa fa-circle-o"></i> View</router-link></li>
          <li><router-link to="/new"><i class="fa fa-circle-o"></i> Create</router-link></li>
        </ul>
      </li>
      <li>
        <router-link to="/menu">
          <i class="fa fa-tasks"></i> <span>Welcome Menu</span>
        </router-link>
      </li>
      <li class="treeview">
        <a href="#" @click="exitApp">
          <i class="fa fa-sign-out"></i> Logout
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { logout } from '../../utils/auth'
export default {
  name: 'app-nav',
  methods: {
    exitApp () {
      logout()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Nav.vue?38662291